import React from "react";
import { Table, Button, Empty } from "antd";
import { HomeworkListItem } from "API";
import { number2Hanzi, sectionDescribe } from "Utils/filter";
import { toFixedNumber } from "pages/homework/utils/filter";

interface HomeworkTableProps {
    list: HomeworkListItem[];
    homeworkStatus: string;
    handleHomework: (
        courseNo: string,
        courseSeq: string,
        weekNo: string,
        dayOfWeek: string,
        section: string,
        continunity: string,
        homeworkStatus: string,
        paperId: string,
        weekTimeId: string
    ) => void;
}

const HomeworkTable = ({
    list,
    homeworkStatus,
    handleHomework
}: HomeworkTableProps) => {
    const renderAction = (text: string, record: HomeworkListItem) => {
        return (
            <Button
                type="primary"
                onClick={() =>
                    handleHomework(
                        record.courseNo,
                        record.courseSeq,
                        record.weekTime,
                        record.week,
                        record.section,
                        record.continunity,
                        homeworkStatus === "3" && record.endTimeCode !== "1"
                            ? "1"
                            : "2",
                        record.paperId,
                        record.weekTimeId
                    )
                }>
                {homeworkStatus === "3" && record.endTimeCode !== "1"
                    ? "修改"
                    : "查看"}
            </Button>
        );
    };

    const renderWeekTime = (weekTime: string, record: HomeworkListItem) => {
        return `第${number2Hanzi(parseInt(weekTime))}周 周${number2Hanzi(
            parseInt(record.week) + 1
        )}`;
    };

    const renderSection = (
        section: string,
        record: HomeworkListItem,
        index: number
    ) => {
        return `${sectionDescribe(section, record.continunity)}`;
    };

    return (
        <Table
            locale={{ emptyText: <Empty description="暂无数据" /> }}
            pagination={false}
            rowKey={record =>
                `${record.courseNo}${record.weekTime}${record.week}${record.section}`
            }
            dataSource={list}
            bordered>
            <Table.Column
                align="center"
                title="序号"
                dataIndex="index"
                render={(text, record, index) => index + 1}
            />
            <Table.Column title="课程" dataIndex="courseName" />
            <Table.Column
                align="center"
                title="周次"
                dataIndex="weekTime"
                render={renderWeekTime}
            />
            <Table.Column
                align="center"
                title="节次"
                dataIndex="section"
                render={renderSection}
            />
            <Table.Column align="center" title="截止日期" dataIndex="endDate" />
            {homeworkStatus === "2" && (
                <Table.Column
                    align="center"
                    title="分数"
                    dataIndex="score"
                    render={score => toFixedNumber(score)}
                />
            )}
            <Table.Column
                align="center"
                title="操作"
                dataIndex="courseNo"
                render={renderAction}
            />
        </Table>
    );
};

export default HomeworkTable;
